// /src/pushSubscribe.js
import { messaging, getToken } from '@/firebase.js'

const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY  // Firebase Console에서 복사한 값
const endpoint = import.meta.env.VITE_DOWNLOAD_ENDPOINT  

export async function requestPermissionAndSubscribe() {
  console.log('알림 권한 요청 중...')

  const permission = await Notification.requestPermission()
  if (permission !== 'granted') {
    console.warn('알림 권한이 거부되었습니다.')
    return
  }

  console.log('알림 권한 허용됨. 토큰 발급 중...')
  try {
    const token = await getToken(messaging, { vapidKey })
    console.log('FCM 토큰:', token)

    // 서버로 구독 요청 보내기
    const res = await fetch(`${endpoint}/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token,
        topic: 'dailyGuidance',
      }),
    })

    if (!res.ok) throw new Error('구독 요청 실패')
    console.log('서버에 topic 구독 요청 완료')
  } catch (err) {
    console.error('토큰 발급 또는 구독 요청 실패:', err)
  }
}


export async function unsubscribeFromTopic() {
  try {
    // 기존에 발급된 토큰 가져오기
    const token = await getToken(messaging, { vapidKey })
    if (!token) {
      console.warn('FCM 토큰이 없습니다. 구독 해제 불가.')
      return
    }

    console.log('토픽 구독 해제 요청 중...')
    const res = await fetch(`${endpoint}/unsubscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token,
        topic: 'dailyGuidance',
      }),
    })

    if (!res.ok) throw new Error('구독 해제 요청 실패')
    console.log('서버에 topic 구독 해제 요청 완료')
  } catch (err) {
    console.error('구독 해제 실패:', err)
  }
}